export default {
  query: {
    search: '搜索',
    duration: '时长',
    to: '至',
    timezone: '时区',
    range: '数据范围',
    day: '天',
    quarter: '季度',
    month: '月',
    productName: '产品名称搜索',
    package: '包名搜索',
    creativeName: '素材名称搜索',
    dcoId: 'DCOID搜索',
    dcoVersionName: 'DCO版本名称搜索',
    combinationId: '组合ID搜索',
    dataDimension: '数据维度',
    dataIndex: '数据指标',
    preview: '预览',
  },
  list: {
    total: '总计',
    product: '产品名称',
    package: '包名',
    creativeName: '素材名称',
    dcoVersionName: 'DCO版本名称',
    combinationId: '组合ID',
    date: '日期',
    month: '月份',
    quarter: '季度',
    impression: '展示',
    click: '点击',
    install: '安装',
  },
  button: {
    search: '查询',
    reset: '重置',
    unfold: '展开',
    preview: '预览',
    export: '导出数据',
  },
}
